import { MapPin, MessageCircle, PhoneCall } from "lucide-react";
import { contact, text } from "../data/content";

export default function MobileActions({ language, onQuote }) {
  return (
    <div className="mobile-actions" aria-label={text(language, "إجراءات سريعة", "Quick actions")} data-testid="mobile-action-bar">
      <a href={contact.phoneHref} data-testid="mobile-call-action"><PhoneCall size={17} /><span>{text(language, "اتصال", "Call")}</span></a>
      <a href={`https://wa.me/${contact.whatsappNumber}`} target="_blank" rel="noopener noreferrer" data-testid="mobile-whatsapp-action"><MessageCircle size={17} /><span>WhatsApp</span></a>
      <a href={contact.mapsHref} target="_blank" rel="noopener noreferrer" data-testid="mobile-location-action"><MapPin size={17} /><span>{text(language, "الموقع", "Location")}</span></a>
      <button type="button" onClick={onQuote} data-testid="mobile-quote-action"><span>+</span><span>{text(language, "عرض سعر", "Quote")}</span></button>
    </div>
  );
}
